<template>
    <div v-show="showMask" class="base-loading" aria-live="assertive" aria-atomic="true" tabindex="-1" ref="focus" :aria-label="label">
        <img class="spinner" src="@/assets/loading.svg" alt="" width="60px">
        <div class="base-loading-text">{{ title }}</div>
    </div>  
</template>

<script>
export default {
    name: 'CommonLoading',
    data() {
        return {
            showMask: false,
            label: '',
            timer: null,
            title: null
        }
    },
    methods: {
        show(title) {
            this.title = title;
            this.showMask = true;
            this.$nextTick(() => {
                this.label = 'loading...';
                this.$refs.focus.focus();
            })
        },
        close() {
            this.title = null;
            this.label = 'loaded';
            this.$refs.focus.focus();
            this.$nextTick(() => {
                this.showMask = false;
            })
        },
    },
    mounted() {
        this.$refs.focus.addEventListener('focus', this.prevent, true); // Use capture phase
    },
    beforeDestroy() {
        this.$refs.focus.removeEventListener('focus', this.prevent, true); // Use capture phase
    },
}
</script>

<style scoped> 
.base-loading {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    align-content: center;
    transition: opacity 0.1s linear;
    z-index: 99;
    top: 0px;
    left: 0px;
}
.base-loading:focus,
.spinner:focus {
    outline: none;
}

.base-loading-text {
    width: 100%;
    text-align: center;
    border: 0;
    padding: 0;
    font-size: 18px;
    font-weight: bold;
    margin-top: 20px;
    color: var(--base-primary-color);
    white-space: nowrap; /* 1 */ 
}
  
.spinner {
    border-radius: 50%;
    width: 60px;
    height: 60px;
    animation: spin 2s linear infinite;
}
  
@keyframes spin {  
    0% { transform: rotate(0deg); }  
    100% { transform: rotate(360deg); }  
}
</style>